import ThemeLexus from './Lexus/ThemeLexus';
import ThemeToyota from './Toyota/ThemeToyota';
import AppFonts from './fonts';
const THEME = process.env.REACT_APP_APP_THEME;
const BRAND = process.env.REACT_APP_THEME_BRAND;

const theme = {
  ...AppFonts,
  ...{
    ...ThemeLexus,
    ...ThemeToyota,
  }[BRAND][THEME],
};

console.log('theme=', BRAND, THEME, theme);

export default theme;
